import api from '@/api/criteria_categories';
import store from '@/store/store';

const fetchCriteriaCategories = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchCriteriaCategories(criteria.pageIndex, criteria.searchTerm, criteria.needAll)
    .then((response) => {
      resolve(response);
      if (!criteria.needAll) {
        store.commit('criteriaCategories/storeCriteriaCategoryList', response);
      }
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchCriteriaCategory = (context, id) => new Promise(((resolve, reject) => {
  api.fetchCriteriaCategory(id)
    .then((response) => {
      resolve(response);
      store.commit('criteriaCategories/storeCriteriaCategory', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchSubCriteriaCategory = (context, id) => new Promise(((resolve, reject) => {
  api.fetchCriteriaCategory(id)
    .then((response) => {
      resolve(response);
      store.commit('criteriaCategories/storeSubCriteriaCategory', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const updateCriteriaCategory = (context, params) => new Promise(((resolve, reject) => {
  api.updateCriteriaCategory(params)
    .then((response) => {
      resolve(response);
      store.commit('criteriaCategories/storeUpdatedCriteriaCategory', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const updateSubCriteriaCategory = (context, params) => new Promise(((resolve, reject) => {
  api.updateCriteriaCategory(params)
    .then((response) => {
      resolve(response);
      store.commit('criteriaCategories/storeUpdatedSubCriteriaCategory', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const createCriteriaCategory = (context, params) => new Promise(((resolve, reject) => {
  api.createCriteriaCategory(params)
    .then((response) => {
      resolve(response);
      store.commit('criteriaCategories/storeCreatedCriteriaCategory', response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const deleteCriteriaCategory = (context, id) => new Promise(((resolve, reject) => {
  api.deleteCriteriaCategory(id)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        console.error(error);
      reject(error);
    });
}));

const fetchCriteriaCategoryTree = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchCriteriaCategoryTree(criteria.forStatement, criteria.language)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchStatementCriteriaCategory = () => new Promise(((resolve, reject) => {
  api.fetchStatementCriteriaCategory()
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const fetchCriteriaCategoryTreeChild = (context, criteria) => new Promise(((resolve, reject) => {
  api.fetchCriteriaCategoryTreeChild(criteria.id, criteria.forstatement, criteria.siteId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const CriteriaCategoryTreeSearch = (context, criteria) => new Promise(((resolve, reject) => {
  api.CriteriaCategoryTreeSearch(criteria.term, criteria.filterTypes)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));

const CriteriaCategoryForStatementTreeSearch = (context, criteria) => new Promise(((resolve, reject) => {
  api.CriteriaCategoryForStatementTreeSearch(criteria.term, criteria.siteId)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
        reject(error);
    });
}));


export default {
  fetchCriteriaCategories,
  fetchCriteriaCategory,
  fetchSubCriteriaCategory,
  createCriteriaCategory,
  updateCriteriaCategory,
  updateSubCriteriaCategory,
  deleteCriteriaCategory,
  fetchCriteriaCategoryTree,
  fetchCriteriaCategoryTreeChild,
  CriteriaCategoryTreeSearch,
  CriteriaCategoryForStatementTreeSearch,
  fetchStatementCriteriaCategory,
};




// WEBPACK FOOTER //
// ./src/store/modules/criteria_categories/actions.js